import { gql } from '@apollo/client';
import { TypedDocumentNode } from '@graphql-typed-document-node/core';

interface GetAddressDetailsResponse {
  getAddressDetails: {
    address_id: string;
    address: string;
    street_number: string;
    street: string;
    streetType: string;
    suburb: string;
    city: string;
    country: string;
    postalCode: string;
  };
}

interface GetAddressDetailsVariables {
  id: string;
}

export const getAddressDetails = gql`
  query GetAddressDetails($id: String!) {
    getAddressDetails(id: $id) {
      address_id
      address
      street_number
      street
      streetType
      suburb
      city
      country
      postalCode
    }
  }
` as TypedDocumentNode<GetAddressDetailsResponse, GetAddressDetailsVariables>;
